import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default, { useRef, useCallback, useEffect } from 'react';
import classNames from 'classnames';
import menuStyles from '../NewMenu.js';
import '../../../utils/index.js';
import Check from '../../Checkbox/Check.js';
import mergeRefs from '../../../utils/mergeRefs/mergeRefs.js';
import wrapEvent from '../../../utils/wrapEvent/wrapEvent.js';

const MenuItem = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    role,
    tabIndex = 0,
    children: label,
    className,
    disabled,
    onSelect,
    onKeyDown,
    onClick,
    isSelected = false,
    isHighlighted = false,
    isFocused = isHighlighted,
    isMultiSelect = false,
    isSelectable = false,
    'aria-checked': ariaChecked,
    ...rest
  } = _ref;
  const itemRef = useRef();
  const defaultRole = isSelectable ? isMultiSelect ? 'menuitemcheckbox' : 'menuitemradio' : 'menuitem';
  const handleSelect = useCallback(e => {
    if (typeof onSelect === 'function' && !disabled) {
      onSelect(e);
    }
  }, [disabled, onSelect]);
  useEffect(() => {
    var _itemRef$current;
    /* preventScroll isn't strictly needed.
     * For keyboard users it makes no difference since the item is already in view when .focus() is called.
     * For mouse users, it prevents scrolling from occurring when hovering over a menu item that is partially out of view.
     */
    if (isHighlighted) (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus({
      preventScroll: true
    });
  }, [isHighlighted]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React__default.createElement("div", _extends({}, rest, {
      ref: mergeRefs(itemRef, ref),
      role: role !== null && role !== void 0 ? role : defaultRole,
      tabIndex: tabIndex,
      "aria-disabled": disabled,
      "aria-checked": isSelectable ? isSelected : ariaChecked,
      className: classNames(className, menuStyles.menuItem, {
        [menuStyles.active]: isHighlighted,
        [menuStyles.focus]: isFocused,
        [menuStyles.selected]: isSelected
      }),
      onKeyDown: wrapEvent(onKeyDown, e => {
        if (e.key === ' ' || e.key === 'Enter') {
          handleSelect(e);
          e.preventDefault(); // prevent scroll
        }
      }),
      onClick: wrapEvent(onClick, handleSelect)
    }), isMultiSelect && /*#__PURE__*/React__default.createElement(Check, {
      className: classNames(menuStyles.checkbox, {
        [menuStyles.highlighted]: isHighlighted && !isSelected
      }),
      checked: isSelected,
      disabled: disabled
    }), label)
  );
});

export { MenuItem as default };
